import Service from '@/helpers/service'

export default {

    show() {
        return Service().get('app-version/show');
    },
    update(params) {
        return Service().post('app-version/update', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}
